import {Injectable} from '@angular/core';
import {Vacancy} from './models/vacancy';
import {VacancyStatus} from './models/vacancy-status.enum';

@Injectable({
  providedIn: 'root'
})
export class VacancyService {

  private vacancies: Vacancy[] = [
    {
      id: 1,
      fullDescription: "Description 1",
      requiredCertificates: [1, 2],
      shortDescription: "Scrum Master",
      startDate: new Date(),
      deadline: new Date(),
      status: VacancyStatus.OPEN,
      candidates: []
    }
  ];

  constructor() { }

  public getAllVacancies(withStatus?: VacancyStatus): Vacancy[] {
    return this.vacancies.filter(vacancy => withStatus === undefined || vacancy.status === withStatus);
  }

  public getById(id: number): Vacancy {
    return this.vacancies.filter(vacancy => vacancy.id === id)[0];
  }


}

